<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'BUYERS.DOCUMENT_LABEL' | translate }}</h3>
    </div>
  </div>
  <div class="sp-width__full sp-margin__top sp-buyer-details-general-document__grid sp-grid__column-gap-x2">
    <app-shared-info
      [label]="'BUYERS.DOC_ISSUER_TYPE_LABEL'"
      [content]="buyer?.document?.issuer_type || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.DOC_ISSUER_LABEL'"
      [content]="buyer?.document?.issuer || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.DOC_ISSUE_COUNTRY_LABEL'"
      [content]="buyer?.document?.issue_country || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.DOC_ISSUE_PROVINCE_LABEL'"
      [content]="buyer?.document?.issue_province || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.DOC_NUMBER_LABEL'"
      [content]="buyer?.document?.doc_number || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.DOC_TYPE_LABEL'"
      [content]="buyer?.document?.doc_type || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.DOC_EMISSION_DATE_LABEL'"
      [content]="(buyer?.document?.emission_date | date : 'dd-MM-yyyy') || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.DOC_EXPIRATION_DATE_LABEL'"
      [content]="(buyer?.document?.expiration_date | date : 'dd-MM-yyyy') || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.DOCUMENT_LABEL'"
      [content]="'BUYERS.DOCUMENT_DOWNLOAD_CTA'"
      [content_class]="'sp-text__ellipsized sp-text__link'"
      [is_content_clickable]="true"
      (content_click)="onDownloadClick()"></app-shared-info>
  </div>
</div>
